module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.$auth.user()) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "permanent": _vm.drawer,
      "hide-overlay": "",
      "width": "200"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "person"
  }, [_vm._v(_vm._s(_vm.$auth.user().displayName || _vm.$auth.user().email))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/realtime-database')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Kalkulator")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/Solarspot')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Ustalenia montażowe")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/Kontakt')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Kontakt z projektantem")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/update-profile')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Aktualizacja profilu")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Wyloguj się")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [(_vm.$auth.user()) ? _c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "logo",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": require("./../assets/img/logo-mini.png"),
      "alt": "SolarSpot logo"
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("App")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.$auth.user()) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Wyloguj się")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": ""
    }
  }, [_c('span', {
    staticClass: "footer"
  }, [_vm._v("© 2019 www.ecoprojektant.pl")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7922030e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 160
// module chunks = 1